{
  "Breadcrumbs": {
    "companies": "Companies",
    "users": "Users",
    "ReturnProcess": "Return requests",
    "deliveryNotifications": "Delivery Notifications",
    "dashboard": "Dashboard"
  }
}
